import { useEffect } from 'react'
import { updateDelay } from '../utils/updateDelay'

interface UseListViewDataUpdateProps {
  dataUpdateTrigger?: boolean
  setDataUpdateTrigger?: (value: boolean) => void
  onUpdate?: () => Promise<void>
  pageIndex: number
  pageSize: number
  setIsLoading?: (loading: boolean) => void
}

export const useListViewDataUpdate = ({
  dataUpdateTrigger,
  setDataUpdateTrigger,
  onUpdate,
  pageIndex,
  pageSize,
  setIsLoading,
}: UseListViewDataUpdateProps) => {
  useEffect(() => {
    // Trigger a data update when credit, items or contentAnalysis is updated
    const updateList = async () => {
      if (setIsLoading) setIsLoading(true)
      await updateDelay({
        then: onUpdate ? async () => await onUpdate() : undefined,
      })
      if (setIsLoading) setIsLoading(false)
    }

    if (dataUpdateTrigger && setDataUpdateTrigger) {
      updateList().then(() => {
        // Reset the trigger after data update completes
        setDataUpdateTrigger(false)
      })
    }
  }, [
    dataUpdateTrigger,
    pageIndex,
    pageSize,
    setDataUpdateTrigger,
    onUpdate,
    setIsLoading,
  ])
}
